var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-card",
        { staticClass: "sticky-container", attrs: { shadow: "never" } },
        [
          _c(
            "el-tabs",
            {
              model: {
                value: _vm.activeKey,
                callback: function ($$v) {
                  _vm.activeKey = $$v
                },
                expression: "activeKey",
              },
            },
            _vm._l(_vm.tabPanes, function (item, index) {
              return _c(
                "el-tab-pane",
                { key: index, attrs: { label: item.title, name: item.name } },
                [
                  index === 0 ? _c("mall-config") : _vm._e(),
                  index === 1 ? _c("wechat-config") : _vm._e(),
                  index === 2 ? _c("payment-config") : _vm._e(),
                  index === 3 ? _c("profit-config") : _vm._e(),
                ],
                1
              )
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }